import { useTranslation } from 'react-i18next';
import { Check, Minus } from 'lucide-react';

import { cn } from '@/lib/utils';

/** Included (an ink check) or not (a grey dash), named for screen readers. */
export function IncludedMark({ included, className }: { included: boolean; className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      role="img"
      aria-label={included ? t('ADMIN_PLANS.INCLUDED') : t('ADMIN_PLANS.NOT_INCLUDED')}
      className={cn('inline-flex size-5 shrink-0 items-center justify-center', included ? 'text-foreground' : 'text-muted-foreground/60', className)}
    >
      {included ? <Check className="size-4" /> : <Minus className="size-4" />}
    </span>
  );
}
